(function(){
'use strict';
var D=document,H=D.documentElement,B=D.body.classList;
var IDX=B.contains('tpl-index'),LST=B.contains('tpl-blog')||B.contains('tpl-collection')||B.contains('tpl-search');
if(!IDX&&!LST)return;
if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
H.classList.add('rv-on');
if(LST){var st=D.createElement('style');st.textContent='.rv-on main .wrap{overflow-x:clip}';D.head.appendChild(st)}
var vh=innerHeight,els=[];
function tag(sel,mode,opt){opt=opt||{};[].forEach.call(D.querySelectorAll('main '+sel),function(e,k){
if(e.hasAttribute('data-rv'))return;
var m=typeof mode==='function'?mode(e,k):mode;
e.setAttribute('data-rv',m);
e.style.setProperty('--i',opt.stagger===false?0:Math.min(opt.base===undefined?k:k+opt.base,6));
els.push(e);});}
/* card grids: first column from the start edge, last column from the end edge, the middle rises */
function grid(sel){var list=[].slice.call(D.querySelectorAll('main '+sel));if(!list.length)return;
var xs=[];list.forEach(function(e){var x=Math.round(e.getBoundingClientRect().left);if(xs.indexOf(x)<0)xs.push(x)});
var rtl=H.dir==='rtl';xs.sort(function(a,b){return rtl?b-a:a-b});
var cols=xs.length;
list.forEach(function(e){if(e.hasAttribute('data-rv'))return;
var r=e.getBoundingClientRect(),c=xs.indexOf(Math.round(r.left));
var m=cols<2?'u':c===0?'s':c===cols-1?'e':'u';
e.setAttribute('data-rv',m);e.style.setProperty('--rvo','min(24vw,240px)');e.style.setProperty('--i',Math.min(c,3));els.push(e);})}
if(LST){
tag('.feature > a.card','s',{stagger:false});
tag('.feature > div','e',{stagger:false});
grid('.grid > .card');
tag('.pager','u',{stagger:false});
}
if(IDX){
tag('.room__head > h2','s',{stagger:false});
tag('.room__head > a,.room__head .room__tools','e',{stagger:false});
tag('.bento .lead','w',{stagger:false});
tag('.bento .side .mini','e');
tag('.dlist li',function(e,k){return k%2?'e':'s'});
tag('.rail > *',function(e,k){return k%2?'e':'s'},{stagger:false});
[].forEach.call(D.querySelectorAll('main .rail > [data-rv]'),function(e,k){e.style.setProperty('--rvo','min(22vw,220px)');e.style.setProperty('--i',Math.min(Math.floor(k/2),4))});
tag('.tod > div:first-child','s',{stagger:false});
tag('.tod > div:last-child','e',{stagger:false});
tag('.terms a','u');
tag('.series__c','s',{stagger:false});
tag('.series > *:not(.series__c)','e');
tag('.region > :first-child,.jw > :first-child,.partners-cta > :first-child,.nl > :first-child','s',{stagger:false});
tag('.region > :last-child,.jw > :last-child,.partners-cta > :last-child,.nl > :last-child','e',{stagger:false});
tag('.cars .kicker,.cars .cars__title,.cars .lede','s');
tag('.grid--4 .pcard','u');
tag('.pcard__media','w',{stagger:false});
}
var io=new IntersectionObserver(function(en){en.forEach(function(x){if(!x.isIntersecting)return;var e=x.target;io.unobserve(e);e.classList.add('rv-in');
setTimeout(function(){e.removeAttribute('data-rv');e.classList.remove('rv-in');e.classList.add('rv-done');e.style.removeProperty('--i');e.style.removeProperty('--rvo')},2200);});},{rootMargin:'0px 0px -7% 0px',threshold:.06});
els.forEach(function(e){
var r=e.getBoundingClientRect();
if(IDX&&r.top<vh*.92&&r.bottom>0){e.removeAttribute('data-rv');e.classList.add('rv-done');return;}
io.observe(e);});
})();
